import { render, staticRenderFns } from "./WithdrawOffDetail.vue?vue&type=template&id=574bc66c&scoped=true"
import script from "./WithdrawOffDetail.vue?vue&type=script&lang=js"
export * from "./WithdrawOffDetail.vue?vue&type=script&lang=js"
import style0 from "./WithdrawOffDetail.vue?vue&type=style&index=0&id=574bc66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574bc66c",
  null
  
)

export default component.exports